/**
 * URL safety check for links rendered from card payloads.  Used by every
 * card that links to a URL from its payload (_CardShell, _PassageList,
 * EventsCard, CommunityDaysCard, RaidBossesCard, LoreCard, _seasonShared).
 */

/** Whitelist `url` to http/https schemes only.  Defense against
 * the snapshot-injection vector: a malicious POST /share request could
 * store a VisualPayload whose `source_url` is `javascript:fetch(...)`,
 * which would then render as a clickable link on /s/<token>.  React
 * 18 only blocks `javascript:` URLs with a warning in dev; in prod
 * it still renders them.  Strip the link entirely for any non-http(s)
 * scheme (data: included).  Backend share.py applies the same check
 * before persisting — this is the second line of defense. */
export function isSafeUrl(url: string | null | undefined): url is string {
  if (!url) return false;
  try {
    const parsed = new URL(url, "https://scoutdex.io");
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}
